package org.lennycodes.hldi.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.fontSize
import com.varabyte.kobweb.compose.css.lineHeight
import com.varabyte.kobweb.compose.dom.svg.Text
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.fontFamily
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.lineHeight
import org.jetbrains.compose.web.css.marginBottom
import org.jetbrains.compose.web.css.maxWidth
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.paddingTop
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import org.lennycodes.hldi.constants.HLDITheme
import org.lennycodes.hldi.data.MissionBlock
import org.lennycodes.hldi.styles.missionVisionCardStyle


 val missionBlocks = listOf(
    MissionBlock(
        icon = "🎯",
        title = "Our Mission",
        description = "RN-HLDI Stands to provide for survival, protection, social harmony and development of all people in Tanzania Mainland by addressing any conditions that threaten their physical and civil life and hinder socio-economic development targeting the marginalized community and vulnerable groups.\n"
    ),
    MissionBlock(
        icon = "🔭",
        title = "Our Vision",
        description = "Human Life Defence Department envisions a community in which human life and development are guaranteed, the dignity of human person is respected and people are free from all dehumanizing conditions."
    ),
    MissionBlock(
        icon = "🛡️",
        title = "Our Motto",
        description = "Working together for the protection and promotion of dignity and fundamental human rights."
    )
)
@Composable
fun MissionVisionCard(block: org.lennycodes.hldi.data.MissionBlock) {
    Div(
        attrs = Modifier.then(missionVisionCardStyle.toModifier()).toAttrs()
    ) {
        Div(
            attrs = {
                style {
                    paddingTop(32.px)
                    fontSize(40.px)
                    marginBottom(16.px)
                }
            }
        ) {
            Text(block.icon)
        }
        H2(
            attrs = {
                style {
                    fontSize(28.px)
                    color(HLDITheme.Colors.primary)
                    marginBottom(16.px)
                    fontFamily("Playfair Display", "serif")
                }
            }
        ) {
            Text(block.title)
        }
        P(
            attrs = {
                style {
                    fontSize(16.px)
                    lineHeight("1.8")
                    color(HLDITheme.Colors.text)
                    maxWidth(360.px)
                }
            }
        ) {
            Text(block.description)
        }
    }
}
